module.exports = __webpack_public_path__ + "img/gyermektamogatas-projekt-2.edd9d963.jpg";